import { requestGet } from '@/common/request';

export interface listManageChannelRes {
  ret: string;
  msg: string;
  data: {};
}

// 查询我管理的频道列表
export async function listManageChannel(query?: any): Promise<listManageChannelRes> {
  return await requestGet('/channelActivity/listManageChannel', query);
}
